import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaLinkedin, FaPhone, FaGithub } from 'react-icons/fa';

const Contact = () => {
  return (
    <section id="contact" className="my-20 max-w-3xl mx-auto px-4">
      <motion.h2
        className="text-3xl font-bold mb-6 text-softPurple"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
      >
        Contact
      </motion.h2>
      <div className="space-y-4 text-gray-300 text-lg">
        <p>
          <FaEnvelope className="inline mr-2 text-softPurple" />
          <a href="mailto:hello@tobiakomolafe.com" className="hover:text-glow">
            hello@tobiakomolafe.com
          </a>
        </p>
        <p>
          <FaLinkedin className="inline mr-2 text-softPurple" />
          <a
            href="https://linkedin.com/in/akomolafetech"
            target="_blank"
            rel="noreferrer"
            className="hover:text-glow"
          >
            linkedin-Technical
          </a>
        </p>
                <p>
          <FaLinkedin className="inline mr-2 text-softPurple" />
          <a
            href="https://www.linkedin.com/in/victorakomolafe/"
            target="_blank"
            rel="noreferrer"
            className="hover:text-glow"
          >
            linkedin-Engineering
          </a>
        </p>
        {/* Phone Numbers Masked */}
        {/* <p>
          <FaPhone className="inline mr-2 text-softPurple" />
          <a href="tel:************" className="hover:text-glow">
            +1 (742) ***-**** (Canada) [masked for privacy]
          </a>
        </p>

        <p>
          <FaPhone className="inline mr-2 text-softPurple" />
          <a href="tel:************" className="hover:text-glow">
            +234 (703) ***-**** (Nigeria) [masked for privacy]
          </a>
        </p> */}

        <p>
          <FaGithub className="inline mr-2 text-softPurple" />
          <a
            href="https://github.com/akomolafevicto"
            target="_blank"
            rel="noreferrer"
            className="hover:text-glow"
          >
            github.com/akomolafevicto
          </a>
        </p>
      </div>
    </section>
  );
};

export default Contact;
